// components/NewCaseWizard/MobileStepper.tsx
import React from 'react';

interface MobileStepperProps {
  currentStep: number;
  totalSteps: number;
  currentStepName: string;
  nextStepName?: string;
}

export const MobileStepper = ({
  currentStep,
  totalSteps,
  currentStepName,
  nextStepName,
}: MobileStepperProps) => {
  const progress = currentStep / totalSteps;
  
  // SVG circle properties
  const radius = 24;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress);

  return (
    <div className="flex items-center gap-4 p-4">
      {/* Circular Progress Indicator */}
      <div className="relative h-14 w-14">
        <svg className="h-full w-full" viewBox="0 0 52 52">
          {/* Background circle */}
          <circle
            cx="26"
            cy="26"
            r={radius}
            strokeWidth="4"
            className="stroke-slate-200 dark:stroke-gray-600"
            fill="transparent"
          />
          {/* Progress circle */}
          <circle
            cx="26"
            cy="26"
            r={radius}
            strokeWidth="4"
            className="stroke-teal-500"
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 26 26)"
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-title-page-color-100 dark:text-white">
          {currentStep}/{totalSteps}
        </span>
      </div>

      {/* Step Text Information */}
      <div>
        <h3 className="text-base font-semibold text-title-page-color-100 dark:text-white">{currentStepName}</h3>
        {nextStepName && (
          <p className="text-sm text-title-page-color-300 dark:text-gray-400">
            Next: {nextStepName}
          </p>
        )}
      </div>
    </div>
  );
};